import React from 'react'
import CancelarPenalizacionCamion from '../containers/CancelarPenalizacionCamion'
import PenalizadoEnPlaya from '../containers/PenalizadoEnPlaya'

export const COLUMNS_CAMIONES_PENALIZADOS = [
  {
    name: 'patente',
    label: 'Patente',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaVencimiento',
    label: 'Vencimiento',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'

    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox'
    }
  },
  {
    name: 'tipoDeTransporte',
    label: 'Tipo de transporte',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'motivo',
    label: 'Motivo',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'numero',
    label: 'Carta de porte automotor',
    options: {
      filter: false,
      sort: true,
      customBodyRender: value => {
        return <PenalizadoEnPlaya numero={value} />
      }
    }
  },
  {
    name: 'patente',
    label: ' ',
    options: {
      print: false,
      filter: false,
      sort: false,
      viewColumns: false,
      customBodyRender: value => {
        return <CancelarPenalizacionCamion patente={value} />
      }
    }
  }
]

export const COLUMNS_CAMIONES_PENALIZADOS_TO_PRINT = [
  {
    name: 'fechaVencimiento',
    label: 'Vencimiento',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'tipoDeTransporte',
    label: 'Tipo de transporte',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'patente',
    label: 'Patente',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'motivo',
    label: 'Motivo',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'cartadeporte',
    label: 'Carta de porte',
    width: 80,
    mantenerCase: true
  }
]
